import React, { useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import DownloadForOfflineOutlinedIcon from "@mui/icons-material/DownloadForOfflineOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";

/** Panel contenedor de filtros + acciones */
export const PygToolbarPanel = ({ children, variant = "default" }) => {
  const theme = useTheme();
  const sidebar = variant === "sidebar";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: sidebar ? "column" : { xs: "column", lg: "row" },
        alignItems: sidebar ? "stretch" : { xs: "stretch", lg: "flex-end" },
        gap: 1,
        p: sidebar ? 1.25 : 1.25,
        height: sidebar ? "auto" : "auto",
        borderRadius: 2,
        bgcolor: theme.palette.background.paper,
        border: "1px solid",
        borderColor: theme.palette.divider,
        boxShadow:
          theme.palette.mode === "dark"
            ? "0 2px 8px rgba(0,0,0,0.22)"
            : "0 2px 8px rgba(15,23,42,0.05)",
      }}
    >
      {children}
    </Box>
  );
};

/** Zona de selects (ocupa el espacio disponible) */
export const PygToolbarFilters = ({ children, variant = "default" }) => {
  const sidebar = variant === "sidebar";
  return (
    <Box
      sx={{
        flex: sidebar ? undefined : 1,
        minWidth: 0,
        display: "grid",
        gridTemplateColumns: sidebar
          ? "minmax(0, 1fr) minmax(0, 1fr)"
          : {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
              lg: "minmax(0, 1.35fr) 92px minmax(0, 1fr)",
            },
        gap: sidebar ? 1.5 : 1,
        mb: 0.5,
        alignItems: "end",
      }}
    >
      {children}
    </Box>
  );
};

/** Menú único de exportación */
export const PygExportMenu = ({ disabled, items }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);

  return (
    <>
      <Button
        variant="outlined"
        disabled={disabled}
        onClick={(e) => setAnchor(e.currentTarget)}
        endIcon={<KeyboardArrowDownIcon />}
        startIcon={<DownloadForOfflineOutlinedIcon />}
        sx={{
          height: 40,
          flexShrink: 0,
          width: "100%",
          fontWeight: 700,
          borderRadius: 1.5,
          px: 1.75,
          whiteSpace: "nowrap",
          bgcolor: alpha(theme.palette.primary.main, 0.08),
          borderColor: alpha(theme.palette.primary.main, 0.35),
          color: "primary.dark",
          "&:hover": {
            bgcolor: alpha(theme.palette.primary.main, 0.14),
            borderColor: alpha(theme.palette.primary.main, 0.5),
          },
        }}
      >
        {t("pygAnalitico.export")}
      </Button>
      <Menu
        anchorEl={anchor}
        open={open}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: { minWidth: 220, borderRadius: 2, mt: 0.5 },
          },
        }}
      >
        {items.map((item) => (
          <MenuItem
            key={item.key}
            disabled={item.disabled}
            onClick={() => {
              setAnchor(null);
              item.onClick?.();
            }}
          >
            <ListItemIcon>
              <DownloadForOfflineOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ fontWeight: 600 }}>
              {item.label}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
